import type { RadioRootProps } from '@base-ui/react';

import { Field as BaseField, Radio as BaseRadio } from '@base-ui/react';

import { clsx, clsxs } from '~/styles/utils';

import { Icon } from '../../Icon/Icon';
import { fieldItemStyle, indicatorStyle, radioControlThemeStyle, radioRootStyle } from './RadioRoot.css';

type Props = RadioRootProps;

export const RadioRoot = ({ children, ...delegated }: Props) => {
  return (
    <BaseField.Item className={clsx(radioControlThemeStyle, fieldItemStyle)}>
      <BaseRadio.Root {...delegated} className={clsxs(radioRootStyle, delegated.className)}>
        <BaseRadio.Indicator
          className={indicatorStyle}
          keepMounted
          render={(props, state) => <Icon {...props} name={state.checked ? 'RadioButtonChecked' : 'RadioButtonUnchecked'} />}
        />

        {children}
      </BaseRadio.Root>
    </BaseField.Item>
  );
};
